import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { styleBlock } from "../styleBlock";
export default class Banner extends React.PureComponent {
    render() {
        const { title, htmlContent, link, imageUrl, className } = this.props;
        const classNames = styleBlock("banner");
        const cn = classNames({}).mix(className);
        return (React.createElement(Card, { className: "overflow-hidden " + cn.toString() },
            React.createElement(Card.Body, { className: "p-0" },
                React.createElement(Row, { noGutters: true },
                    React.createElement(Col, { xs: 12, lg: 5, className: "d-flex flex-wrap align-items-center" },
                        React.createElement("span", { className: "p-4 p-sm-5" },
                            React.createElement("h2", { className: "display-2 mb-4" }, title),
                            React.createElement("div", { className: "mb-4 font-size-md text-gray", dangerouslySetInnerHTML: { __html: htmlContent } }),
                            link)),
                    React.createElement(Col, { xs: 12, lg: 7, className: "overflow-hidden d-flex align-items-center justify-content-end" },
                        React.createElement("img", { src: imageUrl, style: { height: "100%", maxHeight: "360px", objectFit: "cover" }, className: "w-100", role: "presentation" }))))));
    }
}
//# sourceMappingURL=index.js.map